import React, { Component } from "react";
import "./Table.css";

class Loader extends Component {
  // headers = ['head1','head2']
  // items = [[{text:'text',callback:function(){}, align=''},{text:'text',callback:function(){}, align="left"}]]

  render() {
    var width = [];
    var align = [];
    this.props.data.headers.forEach((header) => {
      width.push(header.width);
      var a = "left";
      if (header.align !== undefined) {
        a = header.align;
      }
      align.push(a);
    });
    return (
      <div className="table">
        <div className="table-headers">
          {this.props.data.headers.map((item, i) => (
            <div
              className="table-header"
              key={"header" + i}
              style={{ textAlign: i === 0 ? 'left': 'right', width: '50%' }}
            >
              <div className="table-header-element">{item}</div>
            </div>
          ))}
        </div>
        {this.props.data.items.map((item, i) => (
          <div className="table-item" key={"table" + i}>
            {Object.values(item).map((value, j) => {
              if (j > 1) {
                return null;
              }
              return (
                <div
                  className="table-value"
                  key={"value" + j}
                  style={{ textAlign: j === 0 ? 'left': 'right', width: j === 0 ? '60%': '40%' }}
                >
                  <div className="table-element">
                    {j === 1 ? (+value / 10000000).toLocaleString('en-US') : value}
                  </div>
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Stats/Lists/components/Table/Table.js